import { Injectable, EventEmitter } from '@angular/core';
import { CompatClient, IFrame, IMessage, Stomp } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { environment } from '@environments/environment';
import { backendRestApis } from '@environments/backend-rest-apis';
import { AuthService } from '@app/service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  private stompClient!: CompatClient;
  private connected = false;

  gpsDataEmitter = new EventEmitter<{ lat: number, lon: number }>();

  constructor(private authService: AuthService) {
    this.authService.currentUser.subscribe((user) => {
      if (!user && this.connected) {
        console.log('Korisnik odjavljen - zatvaram WebSocket vezu');
        this.disconnect();
      }
    });
  }

  connect() {
    if (this.connected) {
      return;
    }

    const token = this.authService.accessToken;

    if (!token) {
      console.error('WebSocket connect odbijen - nema access tokena');
      return;
    }

    const socketFactory = () => new SockJS(`${environment.apiUrl}${backendRestApis.ws.ws}`);
    this.stompClient = Stomp.over(socketFactory);
    this.stompClient.debug = () => {};

    this.stompClient.connect(
      { Authorization: `Bearer ${token}` },
      (frame: IFrame) => {
        this.connected = true;
        console.log('Connected: ' + frame);

        this.stompClient.subscribe('/topic/gps', (message: IMessage) => {
          const rawGpsData = JSON.parse(message.body);

          const gpsData = {
            lat: rawGpsData.latitude,
            lon: rawGpsData.longitude
          };

          if (gpsData && typeof gpsData.lat === 'number' && typeof gpsData.lon === 'number') {
            this.gpsDataEmitter.emit(gpsData);
          } else {
            console.error('Invalid GPS data received:', rawGpsData);
          }
        });
      },
      (error: IFrame | string) => {
        this.connected = false;
        console.error('WebSocket connection error:', error);
      }
    );
  }

  disconnect() {
    if (this.stompClient && this.connected) {
      this.stompClient.disconnect(() => {
        this.connected = false;
        console.log('WebSocket disconnected');
      });
    }
  }
}